<template>
    <h1 class="title-logo">Каталог</h1>

    <div v-if="loading == true" class="clx">
        <div class="clx__item">
            <div class="clx__title skeleton-line"></div>
        </div>
        <div class="clx__item">
            <div class="clx__title skeleton-line"></div>
        </div>
        <div class="clx__item">
            <div class="clx__title skeleton-line"></div>
        </div>
        <div class="clx__item">
            <div class="clx__title skeleton-line"></div>
        </div>
    </div>

    <div v-else class="clx scrollable js-scroll">

        <material-item v-for="category in categories" :item="category" :products="products"></material-item>


        <!--
       <div class="clx__item js-clx-item">
           <div class="clx__top-level js-data-popup-open">
               <div class="clx__title">Щебень</div>
               <div class="clx__count js-clx-count"></div><svg class="svg-icon-right svg-icon" width="10" height="20">
                   <use xlink:href="#right"></use>
               </svg>
           </div>
           <div class="clx__sub-level data-popup js-data-popup">
               <div class="data-popup__header">
                   <div class="data-popup__title">Щебень</div><button class="data-popup__close-btn js-data-popup-close" type="button"><svg class="svg-icon-close svg-icon" width="20" height="20">
                   <use xlink:href="#close"></use>
               </svg>
               </button>
               </div>
               <div class="catalog scrollable js-scroll">
                   <form class="catalog-item js-clx-catalog-item" action="/">
                       <div class="catalog-item__title">Щебень (фр.&nbsp;5–10)</div><button class="catalog-item__buy-btn primary-btn" type="submit"><svg class="svg-icon-cart svg-icon" width="20" height="20">
                       <use xlink:href="#cart"></use>
                   </svg>В корзину</button>
                   </form>
                   <form class="catalog-item js-clx-catalog-item _in-cart" action="/">
                       <div class="catalog-item__title">Гранитный щебень (фр.&nbsp;2–5)</div><button class="catalog-item__buy-btn primary-btn" type="submit">
                      В корзине
                   </button>
                   </form>
                   <form class="catalog-item js-clx-catalog-item" action="/">
                       <div class="catalog-item__title">Гранитный щебень (фр.&nbsp;5–10)</div>
                       <div class="catalog-item__count count"><button class="count__btn" type="button">&ndash;</button><input class="count__input" type="text" value="1"><button class="count__btn" type="button">+</button></div>
                   </form>
               </div>
               <div class="bottom-section"><button class="primary-btn lg-btn wide-btn js-data-popup-close" type="button"><span>Готово</span></button></div>
           </div>
       </div>
       <div class="clx__item js-clx-item">
           <div class="clx__top-level js-data-popup-open">
               <div class="clx__title">Пиломатериалы</div>
               <div class="clx__count js-clx-count"></div><svg class="svg-icon-right svg-icon" width="10" height="20">
               <use xlink:href="#right"></use>
           </svg>
           </div>
           <div class="clx__sub-level data-popup js-data-popup">
               <div class="data-popup__header">
                   <div class="data-popup__title">Пиломатериалы</div><button class="data-popup__close-btn js-data-popup-close" type="button"><svg class="svg-icon-close svg-icon" width="20" height="20">
                   <use xlink:href="#close"></use>
               </svg>
               </button>
               </div>
               <div class="scrollable js-scroll">
                   <div class="clx__item js-clx-item">
                       <div class="clx__top-level js-data-popup-open">
                           <div class="clx__title">Доска</div>
                           <div class="clx__count js-clx-count"></div><svg class="svg-icon-right svg-icon" width="10" height="20">
                           <use xlink:href="#right"></use>
                       </svg>
                       </div>
                       <div class="clx__sub-level data-popup js-data-popup">
                           <div class="data-popup__header">
                               <div class="data-popup__title">Доска</div><button class="close-btn data-popup__close-btn js-data-popup-close" type="button"><svg class="svg-icon-close svg-icon" width="20" height="20">
                               <use xlink:href="#close"></use>
                           </svg></button>
                           </div>
                           <div class="catalog scrollable js-scroll">
                               <form class="catalog-item" action="/">
                                   <div class="catalog-item__title">ФК 4х1525</div><button class="catalog-item__buy-btn primary-btn" type="submit"><svg class="svg-icon-cart svg-icon" width="20" height="20">
                                   <use xlink:href="#cart"></use>
                               </svg>В корзину</button>
                               </form>
                               <form class="catalog-item" action="/">
                                   <div class="catalog-item__title">ФК 6х1525</div><button class="catalog-item__buy-btn primary-btn" type="submit"><svg class="svg-icon-cart svg-icon" width="20" height="20">
                                   <use xlink:href="#cart"></use>
                               </svg>В корзину</button>
                               </form>
                               <form class="catalog-item" action="/">
                                   <div class="catalog-item__title">ФК 4х1525</div><button class="catalog-item__buy-btn primary-btn" type="submit"><svg class="svg-icon-cart svg-icon" width="20" height="20">
                                   <use xlink:href="#cart"></use>
                               </svg>В корзину</button>
                               </form>
                               <form class="catalog-item" action="/">
                                   <div class="catalog-item__title">ФК 6х1525</div><button class="catalog-item__buy-btn primary-btn" type="submit"><svg class="svg-icon-cart svg-icon" width="20" height="20">
                                   <use xlink:href="#cart"></use>
                               </svg>В корзину</button>
                               </form>
                           </div>
                           <div class="bottom-section"><button class="primary-btn lg-btn wide-btn js-data-popup-close" type="button"><span>Готово</span></button></div>
                       </div>
                   </div>
                   <div class="clx__item js-clx-item">
                       <div class="clx__top-level js-data-popup-open">
                           <div class="clx__title">Фанера</div>
                           <div class="clx__count js-clx-count"></div><svg class="svg-icon-right svg-icon" width="10" height="20">
                           <use xlink:href="#right"></use>
                       </svg>
                       </div>
                       <div class="clx__sub-level data-popup js-data-popup">
                           <div class="data-popup__header">
                               <div class="data-popup__title">Фанера</div><button class="close-btn data-popup__close-btn js-data-popup-close" type="button"><svg class="svg-icon-close svg-icon" width="20" height="20">
                               <use xlink:href="#close"></use>
                           </svg></button>
                           </div>
                           <div class="catalog scrollable js-scroll">
                               <form class="catalog-item" action="/">
                                   <div class="catalog-item__title">ФК 4х1525</div><button class="catalog-item__buy-btn primary-btn" type="submit"><svg class="svg-icon-cart svg-icon" width="20" height="20">
                                   <use xlink:href="#cart"></use>
                               </svg>В корзину</button>
                               </form>
                               <form class="catalog-item" action="/">
                                   <div class="catalog-item__title">ФК 6х1525</div><button class="catalog-item__buy-btn primary-btn" type="submit"><svg class="svg-icon-cart svg-icon" width="20" height="20">
                                   <use xlink:href="#cart"></use>
                               </svg>В корзину</button>
                               </form>
                               <form class="catalog-item" action="/">
                                   <div class="catalog-item__title">ФК 4х1525</div><button class="catalog-item__buy-btn primary-btn" type="submit"><svg class="svg-icon-cart svg-icon" width="20" height="20">
                                   <use xlink:href="#cart"></use>
                               </svg>В корзину</button>
                               </form>
                               <form class="catalog-item" action="/">
                                   <div class="catalog-item__title">ФК 6х1525</div><button class="catalog-item__buy-btn primary-btn" type="submit"><svg class="svg-icon-cart svg-icon" width="20" height="20">
                                   <use xlink:href="#cart"></use>
                               </svg>В корзину</button>
                               </form>
                           </div>
                           <div class="bottom-section"><button class="primary-btn lg-btn wide-btn js-data-popup-close" type="button"><span>Готово</span></button></div>
                       </div>
                   </div>
               </div>
               <div class="bottom-section"><button class="primary-btn lg-btn wide-btn js-data-popup-close" type="button"><span>Готово</span></button></div>
           </div>
       </div>
        -->

    </div>
</template>

<script>

    import IMask from 'imask';

    import MaterialList from '../components/MaterialList.vue'

    export default {

        name: 'Catalog',

        data: function(){
            return {
                loading: true,
                categories:[],
                products:[],
                basketPositions:[],
            };
        },

        created() {
            this.$root.scrollable = false;
            this.$root.pageClass = "";
        },

        mounted:function () {

            let self = this;

            self.$root.instance.get(
                '/catalog/',
            ).then(function (response) {
                if(response.data.status == 'error'){
                    let errors = '';
                    response.data.errors.forEach(function (item) {
                        errors += item.message
                    });
                    alert(JSON.stringify(errors));
                }else{
                    self.categories = response.data.categories;
                    self.products = response.data.products;
                    self.basketPositions = response.data.basket_products;
                    self.loading = false;
                    setTimeout(function () {
                        window.initModules();
                    }, 500);
                }
            });

            document.addEventListener("onSocketMessage", function(data) {
                console.log("onSocketMessage");
                console.log(data);
            });


        },

        components: {
            'material-item': MaterialList,
        },

        methods: {}
    }
</script>
